module.exports = __webpack_public_path__ + "static/media/analytics.dc9a216e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/01/svgs/analytics.svg
// module id = 619
// module chunks = 0